(function (root) {
  "use strict";

  function isCartAddUrl(url) {
    if (!url) return false;
    var path = String(url);
    var query = path.indexOf("?");
    if (query !== -1) path = path.slice(0, query);
    var hash = path.indexOf("#");
    if (hash !== -1) path = path.slice(0, hash);
    return /\/cart\/add(?:\.js)?$/.test(path);
  }

  function productIdFromAdd(data) {
    if (!data || typeof data !== "object") return "";
    if (data.product_id != null && data.product_id !== "") return String(data.product_id);
    var first = data.items && data.items[0];
    if (first && first.product_id != null && first.product_id !== "") return String(first.product_id);
    return "";
  }

  function giftMapFromList(list) {
    var map = {};
    if (!Array.isArray(list)) return map;
    list.forEach(function (item) {
      if (!item || item.price !== 0 || item.product == null || item.product === "") return;
      if (item.gift == null || item.gift === "") return;
      map[String(item.product)] = String(item.gift);
    });
    return map;
  }

  function giftIdForAdd(map, productId, items) {
    if (productId == null || productId === "" || !map) return null;
    var giftId = map[String(productId)];
    if (!giftId) return null;
    var already = (items || []).some(function (item) {
      return item && String(item.variant_id) === String(giftId);
    });
    return already ? null : giftId;
  }

  function isCartChangeUrl(url) {
    if (!url) return false;
    var path = String(url).split("#")[0].split("?")[0];
    return /\/cart\/(change|update)(?:\.js)?$/.test(path);
  }

  // Gift lines added by this script carry the bundle's product id. A gift whose
  // bundle has left the cart is removed, and a gift never counts more than once.
  // Several products can share one gift (giftMap), so the gift stays while any
  // product that gets it is still in the cart. Lines without that property are left alone.
  function orphanGiftFixes(items, giftMap) {
    var list = Array.isArray(items) ? items : [];
    var bundles = {};
    var giftsHeld = {};
    list.forEach(function (item) {
      var props = (item && item.properties) || {};
      if (!item || props._encanto_free_gift) return;
      bundles[String(item.product_id)] = true;
      var gift = giftMap && giftMap[String(item.product_id)];
      if (gift) giftsHeld[String(gift)] = true;
    });
    var fixes = [];
    list.forEach(function (item) {
      var props = (item && item.properties) || {};
      if (!item || !props._encanto_free_gift || !props._encanto_bundle) return;
      var held = bundles[String(props._encanto_bundle)] || giftsHeld[String(item.variant_id)];
      if (!held) fixes.push({ key: item.key, quantity: 0 });
      else if (Number(item.quantity) > 1) fixes.push({ key: item.key, quantity: 1 });
    });
    return fixes;
  }

  function stockLabel(state) {
    var qty = Number(state && state.qty);
    var low = Number(state && state.low);
    if (!Number.isFinite(low)) low = 5;
    var countable = !!(state && state.tracked) && state.policy !== "continue" && Number.isFinite(qty);
    if (!state || state.available === false) return { key: "out", count: null };
    if (countable && qty > 0 && qty <= low) {
      return { key: state.exact ? "low_count" : "low", count: qty };
    }
    if (countable && state.exact && qty > 0) return { key: "count", count: qty };
    return { key: "in", count: null };
  }

  function createCartGift(deps) {
    var inflight = {};
    function consider(productId) {
      var key = String(productId || "");
      if (!key || inflight[key]) return Promise.resolve(false);
      if (!giftIdForAdd(deps.giftMap(), key, [])) return Promise.resolve(false);
      inflight[key] = true;
      var addedId = null;
      return Promise.resolve()
        .then(function () {
          return deps.fetch("/cart.js", { credentials: "same-origin" });
        })
        .then(function (response) {
          if (!response || !response.ok) throw new Error("cart");
          return response.json();
        })
        .then(function (cart) {
          var giftId = giftIdForAdd(deps.giftMap(), key, cart && cart.items);
          if (!giftId) return false;
          addedId = giftId;
          return deps.fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{ id: Number(giftId), quantity: 1, properties: { _encanto_free_gift: "true", _encanto_bundle: key } }],
              sections: "cart_data,mini_cart",
              sections_url: deps.path || "/"
            })
          });
        })
        .then(function (result) {
          if (result === false || result == null) return false;
          if (!result.ok) throw new Error("add");
          return result.json().then(function (data) {
            if (deps.onAdded) deps.onAdded(data, addedId);
            return true;
          });
        })
        .catch(function () { return false; })
        .finally(function () { delete inflight[key]; });
    }
    return { consider: consider };
  }

  var api = {
    isCartAddUrl: isCartAddUrl,
    productIdFromAdd: productIdFromAdd,
    giftMapFromList: giftMapFromList,
    giftIdForAdd: giftIdForAdd,
    stockLabel: stockLabel,
    isCartChangeUrl: isCartChangeUrl,
    orphanGiftFixes: orphanGiftFixes,
    createCartGift: createCartGift
  };

  if (typeof module !== "undefined" && module.exports) module.exports = api;

  function boot() {
    if (root.__encantoPremium) return;
    root.__encantoPremium = true;
    var originalFetch = root.fetch ? root.fetch.bind(root) : null;

    function readGiftMap() {
      var map = {};
      var node = document.getElementById("encanto-gift-map");
      if (node) {
        try {
          map = giftMapFromList(JSON.parse(node.textContent));
        } catch (error) {}
      }
      document.querySelectorAll("[data-enc-gift][data-enc-bundle-product]").forEach(function (badge) {
        var productId = badge.getAttribute("data-enc-bundle-product");
        var giftId = badge.getAttribute("data-enc-gift");
        if (productId && giftId) map[productId] = giftId;
      });
      return map;
    }

    function refreshMiniCart() {
      var section = document.getElementById("shopify-section-mini_cart");
      if (!section || !originalFetch) return Promise.resolve();
      return originalFetch("/?section_id=mini_cart", { credentials: "same-origin" })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, "text/html");
          var fresh = parsed.getElementById("shopify-section-mini_cart");
          if (fresh) section.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }

    function syncCount() {
      if (!originalFetch) return Promise.resolve();
      return originalFetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (!cart || typeof cart.item_count !== "number") return;
          document.querySelectorAll("[data-cart-count]").forEach(function (node) {
            node.textContent = cart.item_count;
            if (cart.item_count > 0) node.classList.remove("t4s-op-0");
          });
        })
        .catch(function () {});
    }

    var gifts = createCartGift({
      fetch: originalFetch,
      giftMap: readGiftMap,
      path: root.location ? root.location.pathname : "/",
      onAdded: function (data) {
        if (root.T4SThemeSP && T4SThemeSP.Cart && data && data.sections && typeof T4SThemeSP.Cart.renderContents === "function") {
          T4SThemeSP.Cart.renderContents(data.sections);
        } else {
          refreshMiniCart();
        }
        syncCount();
      }
    });

    function maybeGift(productId) {
      if (productId) gifts.consider(productId);
    }

    var tidying = false;
    function tidyGifts() {
      if (!originalFetch || tidying) return;
      tidying = true;
      originalFetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var fixes = orphanGiftFixes(cart && cart.items, readGiftMap());
          return fixes.reduce(function (chain, fix) {
            return chain.then(function () {
              return originalFetch("/cart/change.js", {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ id: fix.key, quantity: fix.quantity, sections: "mini_cart", sections_url: root.location ? root.location.pathname : "/" })
              }).then(function (response) { return response.json(); });
            });
          }, Promise.resolve(null)).then(function (data) {
            if (!fixes.length) return;
            if (root.T4SThemeSP && T4SThemeSP.Cart && data && data.sections && typeof T4SThemeSP.Cart.renderContents === "function") {
              T4SThemeSP.Cart.renderContents(data.sections);
            } else {
              refreshMiniCart();
            }
            syncCount();
            if (root.location && /\/cart\/?$/.test(root.location.pathname)) root.location.reload();
          });
        })
        .catch(function () {})
        .finally(function () { tidying = false; });
    }

    if (originalFetch) {
      root.fetch = function (input, init) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var adding = isCartAddUrl(url);
        var changing = isCartChangeUrl(url);
        return originalFetch(input, init).then(function (response) {
          if (changing && response && response.ok) tidyGifts();
          if (adding && response && response.ok && response.clone) {
            response.clone().json().then(function (data) {
              maybeGift(productIdFromAdd(data));
            }).catch(function () {});
          }
          return response;
        });
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__encUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isCartChangeUrl(xhr.__encUrl)) {
        xhr.addEventListener("load", function () {
          if (xhr.status >= 200 && xhr.status < 300) tidyGifts();
        });
      }
      if (isCartAddUrl(xhr.__encUrl)) {
        xhr.addEventListener("load", function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          try {
            maybeGift(productIdFromAdd(JSON.parse(xhr.responseText)));
          } catch (error) {}
        });
      }
      return originalSend.apply(xhr, arguments);
    };

    function paintStock(scope) {
      (scope || document).querySelectorAll("[data-enc-stock]").forEach(function (stock) {
        var form = stock.closest(".t4s-product__info-container") || document;
        var select = form.querySelector('select[name="id"]');
        if (!select || select.selectedIndex < 0) return;
        var option = select.options[select.selectedIndex];
        var text = stock.querySelector("[data-enc-stock-text]");
        if (!option || !text) return;
        var state = stockLabel({
          available: !(option.disabled || option.classList.contains("is--sold-out")),
          qty: option.getAttribute("data-inventoryQuantity"),
          policy: String(option.getAttribute("data-inventoryPolicy") || "").replace(/"/g, ""),
          exact: stock.getAttribute("data-exact") === "true",
          tracked: stock.getAttribute("data-tracked") === "true",
          low: stock.getAttribute("data-low")
        });
        var templates = {
          out: stock.getAttribute("data-label-out"),
          low: stock.getAttribute("data-label-low"),
          low_count: stock.getAttribute("data-label-low-count"),
          count: stock.getAttribute("data-label-count"),
          in: stock.getAttribute("data-label-in")
        };
        var label = templates[state.key] || templates.in || "";
        if (state.count != null) label = String(label).replace("__COUNT__", String(state.count));
        text.textContent = label;
        stock.classList.toggle("is-out", state.key === "out");
        stock.classList.toggle("is-low", state.key === "low" || state.key === "low_count");
      });
    }

    if (root.location && /\/cart\/?$/.test(root.location.pathname)) tidyGifts();

    // Flair-style loading screen (layout/theme.liquid paints it first).
    // Fades out once the page is ready, fades back in when an internal link is
    // followed, and never stays up: a CSS failsafe and timers hide it.
    var curtain = document.querySelector("[data-enc-pt]");
    if (curtain) {
      var reveal = function () {
        root.requestAnimationFrame(function () {
          curtain.classList.remove("is-leaving");
          curtain.classList.add("is-hidden");
        });
      };
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", reveal);
      else reveal();
      root.addEventListener("pageshow", function (event) { if (event.persisted) reveal(); });

      // Window listener runs after the theme's own document-level handlers, so links
      // the theme handles itself (add to cart, quick view, drawers) are already prevented.
      root.addEventListener("click", function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var link = event.target && event.target.closest && event.target.closest("a[href]");
        if (!link) return;
        var href = link.getAttribute("href") || "";
        if (!href || href.charAt(0) === "#" || /^(mailto|tel|sms|javascript):/i.test(href)) return;
        if ((link.target && link.target !== "_self") || link.hasAttribute("download")) return;
        if (link.closest("[data-no-transition], [data-action-atc], [data-action-quickview], [data-action-quickshop]")) return;
        if (link.matches("[data-action-atc], [data-action-quickview], [data-action-quickshop], [data-no-instant]")) return;
        var url;
        try { url = new URL(link.href, root.location.href); } catch (error) { return; }
        if (url.origin !== root.location.origin) return;
        if (url.pathname === root.location.pathname && url.search === root.location.search) return;
        curtain.classList.remove("is-hidden");
        curtain.classList.add("is-leaving");
        // If nothing navigates (blocked or handled elsewhere), lift it again.
        root.setTimeout(reveal, 4000);
      });
    }

    // Product story cards fade up when they scroll into view.
    function setupReveal() {
      var stories = document.querySelectorAll("[data-enc-story].enc-story--animate");
      if (!stories.length || !("IntersectionObserver" in root)) return;
      if (root.matchMedia && root.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
      stories.forEach(function (story) {
        story.classList.add("enc-reveal-ready");
        story.querySelectorAll(".enc-reveal").forEach(function (card) { observer.observe(card); });
      });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setupReveal);
    else setupReveal();

    // Customer Love screenshots: an endless slow strip like Flair's (0.45px per
    // frame on desktop, 0.28 on phones), paused on hover/touch and while off screen.
    function setupReviewStrips() {
      if (root.matchMedia && root.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      document.querySelectorAll("[data-enc-rv-track]").forEach(function (track) {
        if (track.getAttribute("data-ready") === "true") return;
        track.setAttribute("data-ready", "true");
        Array.prototype.slice.call(track.children).forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          clone.setAttribute("alt", "");
          track.appendChild(clone);
        });
        var position = 0;
        var paused = false;
        var visible = !("IntersectionObserver" in root);
        var frame = null;
        var half = 0;
        function measure() { half = track.scrollWidth / 2; }
        function speed() { return root.innerWidth <= 768 ? 0.28 : 0.45; }
        function step() {
          frame = null;
          if (paused || !visible || document.hidden || !track.isConnected) return;
          position -= speed();
          if (half > 0 && Math.abs(position) >= half) position = 0;
          track.style.transform = "translate3d(" + position + "px, 0, 0)";
          frame = root.requestAnimationFrame(step);
        }
        function schedule() {
          if (frame !== null) root.cancelAnimationFrame(frame);
          frame = null;
          if (!paused && visible && !document.hidden && track.isConnected) frame = root.requestAnimationFrame(step);
        }
        function pause() { paused = true; schedule(); }
        function resume() { paused = false; schedule(); }
        track.addEventListener("mouseenter", pause);
        track.addEventListener("mouseleave", resume);
        track.addEventListener("touchstart", pause, { passive: true });
        track.addEventListener("touchend", resume, { passive: true });
        track.addEventListener("touchcancel", resume, { passive: true });
        document.addEventListener("visibilitychange", schedule);
        track.addEventListener("load", measure, true);
        root.addEventListener("resize", measure, { passive: true });
        var sizeObserver;
        if ("ResizeObserver" in root) {
          sizeObserver = new ResizeObserver(measure);
          sizeObserver.observe(track);
        }
        var visibilityObserver;
        if ("IntersectionObserver" in root) {
          visibilityObserver = new IntersectionObserver(function (entries) {
            visible = entries[0] ? entries[0].isIntersecting : true;
            schedule();
          });
          visibilityObserver.observe(track.parentElement);
        }
        function dispose(event) {
          if (!event.target.contains(track)) return;
          if (frame !== null) root.cancelAnimationFrame(frame);
          if (sizeObserver) sizeObserver.disconnect();
          if (visibilityObserver) visibilityObserver.disconnect();
          root.removeEventListener("resize", measure);
          document.removeEventListener("visibilitychange", schedule);
          document.removeEventListener("shopify:section:unload", dispose);
        }
        document.addEventListener("shopify:section:unload", dispose);
        measure();
        schedule();
      });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setupReviewStrips);
    else setupReviewStrips();
    document.addEventListener("shopify:section:load", setupReviewStrips);

    // Share: the phone's share sheet when there is one, otherwise copy the link.
    document.addEventListener("click", function (event) {
      var button = event.target && event.target.closest && event.target.closest("[data-enc-share]");
      if (!button) return;
      event.preventDefault();
      var url = button.getAttribute("data-url") || (root.location && root.location.href) || "";
      var title = button.getAttribute("data-title") || document.title;
      if (root.navigator && navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      if (root.navigator && navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var label = button.querySelector("[data-enc-share-label]");
          if (!label) return;
          var original = label.textContent;
          label.textContent = button.getAttribute("data-copied") || original;
          root.setTimeout(function () { label.textContent = original; }, 2000);
        }).catch(function () {});
      }
    });

    document.addEventListener("change", function (event) {
      if (event.target && event.target.name === "id") {
        paintStock(event.target.closest(".t4s-product__info-container") || document);
      }
    });
    document.addEventListener("click", function (event) {
      if (!event.target || !event.target.closest) return;
      var host = event.target.closest(".t4s-product-form__variants, .t4s-swatch");
      if (!host) return;
      root.setTimeout(function () {
        paintStock(host.closest(".t4s-product__info-container") || document);
      }, 60);
    });
  }

  if (root && root.document) boot();
})(typeof window !== "undefined" ? window : globalThis);
